import { render, staticRenderFns } from "./active-add.vue?vue&type=template&id=53859a42&scoped=true&"
import script from "./active-add.vue?vue&type=script&lang=js&"
export * from "./active-add.vue?vue&type=script&lang=js&"
import style0 from "./active-add.vue?vue&type=style&index=0&id=53859a42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53859a42",
  null
  
)

export default component.exports